import { Model, attr, belongsTo } from '@elatonsev/js-models';
import PhotoModel from './PhotoModel';

export default class PromotionModel extends Model {
  text = attr('string');
  cover = belongsTo(PhotoModel);
}